export interface RenderType {
	title: string;
	id: number;
}

export const RenderTypes: RenderType[] = [
	{
		id: 1,
		title: "Attachment"
	},
	{
		id: 2,
		title: "Embedded"
	}
]
